import { signOut } from "next-auth/react";

export default function useLogout() {
  return () => {
    signOut({ 
      callbackUrl: "/login",
      redirect: true 
    });
  };
}
